<template>
  <div id="mypie" style="height: 300px;width: 440px;z-index: 999;padding-top:20px">

  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  data() {
    return {
      option: {
        title: {
          text: '书籍分类',
          textStyle: {
            color: 'rgb(255, 255, 255)'
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  mounted() {
    let chartDom = document.getElementById('mypie');
    let myChart = echarts.init(chartDom);
    this.option.series[0].data.push({
      name: '专利',
      value: Math.round(Math.random() * 100)   
    })
    this.option.series[0].data.push({
      name: '成果',
      value: Math.round(Math.random() * 100)   
    })
    this.option.series[0].data.push({
      name: '论文',
      value: Math.round(Math.random() * 100)   
    })
    this.option.series[0].data.push({
      name: '期刊',
      value: Math.round(Math.random() * 100)   
    })
    this.option.series[0].data.push({
      name: '报纸',
      value: Math.round(Math.random() * 100)   
    })
    myChart.setOption(this.option)
  }
}
</script>
<style scoped>
#mypie {
  margin-left: 20px;
  margin-bottom: 20px;
  position: relative;
  border: 1px solid #17366c;
  background: linear-gradient(to left, #3897cf, #3897cf) left top no-repeat, linear-gradient(to bottom, #3897cf, #3897cf) left top no-repeat, linear-gradient(to left, #3897cf, #3897cf) right top no-repeat, linear-gradient(to bottom, #3897cf, #3897cf) right top no-repeat, linear-gradient(to left, #3897cf, #3897cf) left bottom no-repeat, linear-gradient(to bottom, #3897cf, #3897cf) left bottom no-repeat, linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat, linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
  background-color: rgba(14, 8, 97, 0.418);
}
</style>


// WEBPACK FOOTER //
// src/components/charts/pie.vue